import React, {useEffect, useRef, useMemo} from 'react';
import wcmUtils from '../../utils/wcmUtils';
import pathUtils from '../../utils/pathUtils';
import {useTranslation} from 'react-i18next';
import useLoadWebModule from '../../hooks/useLoadWebModule';

export default function WebModule(props) {
  const {i18n} = useTranslation();
  const timeout = useRef(0);
  const {sdkLoaded} = useLoadWebModule();
  const isEyewear = pathUtils.isEyewear();
  const isPadLayout = useMemo(() => window.innerWidth < 1366 && window.innerWidth > 600, []);

  const init = () => {
    if (!window.YMK) {
      timeout.current && clearTimeout(timeout.current);
      timeout.current = setTimeout(() => init(), 100);
      return;
    }
    const args = {
      language: wcmUtils.convertLanguage(i18n.language),
      privacyPolicyURL: pathUtils.getPFSiteURL('/business/privacy', i18n.language),
      enableEyewearPD: isEyewear,
      enableRecordMode: isEyewear,
    };
    if (isPadLayout) {
      args.width = 360;
      args.height = 360 * 1.2;
    }
    console.log('[WebModule] args', args);
    window.YMK.init(args);
  };

  useEffect(() => {
    sdkLoaded && init();
  }, [sdkLoaded]);

  return (
    <>
      {isPadLayout && (
        <div
          id="YMK-module-widget"
          style={{
            position: 'fixed',
            bottom: '20px',
            left: 0,
            zIndex: 999999999,
            boxShadow: '0 5px 10px 4px rgba(0, 0, 0, 0.25)',
            height: 'fit-content',
          }}
        />
      )}
      <div className="YMK-icon" />
    </>
  );
}
